import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {NgxSpinnerService} from "ngx-spinner";
import {TypeRequest} from "src/app/components/common/form-dynamic/enum";
import {TipoIdentificacion} from "src/app/components/individual-afiliate-beneficiary/model/tipo-identificacion";
import {
  ValidacionesFechaNacimientoService
} from "src/app/components/individual-afiliate-beneficiary/services/validaciones-fecha-nacimiento.service";
import {ValidacionesService} from "src/app/components/individual-afiliate-beneficiary/services/validaciones.service";
import {MensajeDireccion} from 'src/app/core/enums/direccion-afiliado.enum';
import {DropdownLists} from "src/app/core/helpers/dropdown-lists/dropdown-lists";
import {ValidatorsCustom} from "src/app/core/helpers/validators-custom/validators-custom";
import {IParentescoConTiposIdentificacion} from "src/app/core/models/parentesco/parentesco-interface";
import {
  obtenerSolicitudTipoId,
  SolicitudTiposEnum
} from "src/app/core/models/request/afiliaciones/solicitud-tipos.enum";
import {Afiliate} from "src/app/core/models/request/afiliate";
import {IUser} from "src/app/core/models/user/user";
import {WresponseData} from "src/app/core/models/worker/wresponse-data";
import {DisaffiliationService} from "src/app/core/services/disaffiliation/disaffiliation.service";
import {DetalleSolicitudModel} from "src/app/core/services/gestor/consultas/detalle-solicitud.model";
import {GestorSolicitudesConsultas} from "src/app/core/services/gestor/consultas/gestor-solicitudes-consultas.service";
import {GlobalService} from "src/app/core/services/global/global.service";
import {LocalStorageService} from "src/app/core/services/local-storage/local-storage.service";
import {ModalVariadoService} from "src/app/core/services/modal-variado/modal-variado.service";
import {RequestService} from "src/app/core/services/request/request.service";
import {ValidateData} from "src/app/core/utils/validate-data";
import {environment} from "src/environments/environment";
import {  ObligatoriedadDocumentosService} from "../../../../../../core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { AffiliationService } from "src/app/core/services/affiliation/affiliation.service";
import { IAffiliateTitular, IAffiliateBeneficiary, IAffiliateInformation } from "src/app/core/models/affiliation/iaffiliate-process";
import { EstadoSolicitud } from "src/app/core/models/enum/estado-solicitud.enum";
import { finalize, takeUntil, tap } from "rxjs/operators";
import { Subject } from "rxjs";
import { ParametrosSolicitudValida } from "src/app/core/models/request/parametros-solicitud-valida";
import { BodyRequestValid } from "src/app/core/models/request/solicitud-valida";


@Component({
    selector: "app-formulario-informacion-beneficiario",
    templateUrl: "./formulario-informacion-beneficiario.component.html",
    styleUrls: ["./formulario-informacion-beneficiario.component.scss"],
    standalone: false
})
export class FormularioInformacionBeneficiarioComponent implements OnInit, OnDestroy {
  @Input() beneficiary: FormControl;
  @Input() index: number;
  @Input() showAddress: boolean = true;
  @Input() tipoSolicitud: number

  @Input() parentescos: Array<IParentescoConTiposIdentificacion>;
  @Input() form: FormGroup;
  @Input() dataJson: any;
  @Input() workerData: WresponseData;

  public tiposIdentificacion: Array<TipoIdentificacion>;
  public tipoParentescoSeleccionado: IParentescoConTiposIdentificacion;
  public idRequestType: number = TypeRequest.AfiliateBeneficiary;
  public reasonSelectedName: string;
  public genders = [];
  public urlCategoria;
  public minimaFecha = new Date();
  public maximaFecha = new Date();

  public numeroDocumentoBeneficiario: any;
  public afiliadoData: any;
  public empresaData: any;
  public userloggedin: IUser;
  public isBneficiarioValido: string = "";
  public errorAddress;
  public errAddres = false;
  public deshabilitarEdicion: boolean = false;
  public MensajeDir: string = "";
  public solicitudesEnProcesoAcreditador: Array<any>;
  public solicitudesDeAfiliadoCargadas: boolean = false;
  public coincidenciaEncontrada: boolean = false;
  public afiliadoFromStorage: string;
  private infoBeneficiarioAfiliado: IAffiliateBeneficiary[];
  private infoTitularAfiliado: IAffiliateTitular;
  private destroy$ = new Subject<void>();


  constructor(
    private formBuilder: FormBuilder,
    private _changeDetector: ChangeDetectorRef,
    private _VALIDACIONES: ValidacionesService,
    private _STORAGE: LocalStorageService,
    private _globalService: GlobalService,
    private _spinner: NgxSpinnerService,
    private _validacionesFechaNacimientoSvc: ValidacionesFechaNacimientoService,
    public _ModalVariadoService: ModalVariadoService,
    public requestService: RequestService,
    private gestorSolicitudesConsultas: GestorSolicitudesConsultas,
    private obligatoriedadDocumentosService: ObligatoriedadDocumentosService,
    private _affiliationService: AffiliationService
  ) {
    this.infoBeneficiarioAfiliado = [];
    this.infoTitularAfiliado = {} as IAffiliateTitular;
  }

  ngOnInit() {
    this.urlCategoria =
      "http://40.117.63.112/portalpersonas/assets/pdfs/PDF%20Afiliacion%20de%20Beneficiarios.pdf";
    this.tiposIdentificacion = new Array<TipoIdentificacion>();
    this.genders = DropdownLists.genders;
    !this.workerData
      ? (this.workerData = this._STORAGE.getItemJSON(
        environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION
      ))
      : null;
    this.beneficiary
      .get("parentescoPerCarg")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: IParentescoConTiposIdentificacion) => {
      if (
        !this.beneficiary.get("parentescoPerCarg").disabled &&
        !ValidateData.emptyObject(value)
      ) {
        let beneficiarios = this.form.controls["pacs"] as FormArray;
        this.tiposIdentificacion = value.tiposIdentificacion;
        this.beneficiary.get("tipoDocumentoObjeto").enable();
        this.beneficiary.get("fechaNacimiento").setValue(undefined);
        this.beneficiary.get("tipoDocumentoObjeto").setValue("");
        this.form.get("reason").setValue(value.id);
        this.reasonSelectedName = value.name;
        this.tipoParentescoSeleccionado = value;
        this._VALIDACIONES.getParentescosValidos(
          this.beneficiary,
          beneficiarios
        );
      }
    });
    this.beneficiary
      .get("discapacidad")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
      if (!this.beneficiary.get("discapacidad").disabled) {
        if (this.beneficiary.get("tipoDocumentoObjeto").value) {
          this.obtenerValidacionRangoDeEdad(
            this.beneficiary.get("tipoDocumentoObjeto").value
          );
        }
        this.beneficiary.get("rangoC").setValue(false);
        this.beneficiary.get("fechaNacimiento").updateValueAndValidity();
        this.beneficiary.get("tipoDocumentoObjeto").setValue(undefined);
        this.form.controls["pacs"] = this.formBuilder.array([
          this.beneficiary,
        ]);


      }
    });

    this.beneficiary
      .get("tipoDocumentoObjeto")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: TipoIdentificacion) => {
      if (
        !this.beneficiary.get("tipoDocumentoObjeto").disabled &&
        !ValidateData.emptyObject(value)
      ) {

        this.beneficiary.get("rangoC").setValue(false);
        this.beneficiary.get("fechaNacimiento").enable();
        this.beneficiary.get("tipoDocumento").setValue(value.valor);
        this.obtenerValidacionRangoDeEdad(value);
        this.beneficiary.get("fechaNacimiento").updateValueAndValidity();
      }
    });

    this.beneficiary
      .get("fechaNacimiento")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
      if (value) {
        let rangoC = this._VALIDACIONES.obtenerCategoriaC(
          this.beneficiary.get('parentescoPerCarg').value.id,
          value,
          this.beneficiary.get('discapacidad').value
        );
        this.beneficiary?.get("rangoC").setValue(rangoC);
        this._changeDetector.detectChanges();
      }
    });

    let direccionPrincipal = this.workerData?.validacion_afiliado?.afiliado?.direccion?.direccionPrincipal;
    if (direccionPrincipal != "CL 25 25 25") {
      //this.validarDireccion(direccionPrincipal);
    } else {
      this.beneficiary
        .get("direccionResidencia").setValue("");
      this._changeDetector.detectChanges();
    }
    if (!this.showAddress) {
      this.MensajeDir = MensajeDireccion.DIRECCION_ACTUALIZADA;
    } else {
      this.MensajeDir = MensajeDireccion.DIRECCION_DESACTUALIZADA;
    }

    this._affiliationService.titularAfiliado$
    .pipe(takeUntil(this.destroy$))
    .subscribe(titular => {
      this.infoTitularAfiliado = titular ?? {} as IAffiliateTitular;
    });

    this._affiliationService.beneficiariosAfiliado$
    .pipe(takeUntil(this.destroy$))
    .subscribe(beneficiarios => {
      this.infoBeneficiarioAfiliado = beneficiarios ?? [];
    });

    if(this.form.get('newBeneficiaryAffiliate')){
      this.form.get('newBeneficiaryAffiliate')?.setValue(this.infoTitularAfiliado.numeroDocumento);
    }

    this.form.get("pacs").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.form.updateValueAndValidity();
    });

    this.validacionDireccionBeneficiario();
          this.afiliadoFromStorage = localStorage.getItem(
        environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION
      );
      this.afiliadoData = JSON.parse(this.afiliadoFromStorage)[
        'validacion_afiliado'
        ];
  }

  ngOnDestroy() {
    this.obligatoriedadDocumentosService.resetearDocumentosBeneficiario();
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Valido la direccion del afiliado
   * Esta debe ser tipo Dane
   */
  onBlur(direccion: string) {

    if (!this.ValidacionDirBeneficiario(direccion)) {
      this.validarDireccion(direccion);
    }
  }

  private ValidacionDirBeneficiario(text: string): Boolean {
    //RegularExpressions.CARACTER_VALIDO
    const regex = /^[a-zA-Z0-9# -]+$/; // Expresión regular que permite letras, números, "-", y "#"
    if (text && !regex.test(text)) {
      return true;
    }
    return false;
  }

  async validarDireccion(direccion: string) {
    if (!direccion) return;
    await this._spinner.show();
    let respuesta = null;
    let exitoso = false;
    const campoDireccion = this.beneficiary.get('direccionResidencia');
    const customErrors = {messageError: MensajeDireccion.DIRECCION_ERROR};
    try {
      respuesta = await this._globalService.formatoDANE(direccion).toPromise();
      if (respuesta.success) {
        campoDireccion.setValue(respuesta.body);
        this.errAddres = true;
        exitoso = true;
      } else {
        campoDireccion.setErrors(customErrors);
        this.errAddres = false;
        this.errorAddress = MensajeDireccion.DIRECCION_ERROR;
      }
    } catch (err) {
      if (err?.error?.code?.code === 422) {
        campoDireccion.setErrors(customErrors);
        this.errAddres = false;
        this.errorAddress = MensajeDireccion.DIRECCION_ERROR;
      }
      exitoso = false;
    } finally {
      this.deshabilitarEdicion = exitoso;
      this._changeDetector.detectChanges();
      await this._spinner.hide();
    }

    return respuesta;
  }

  convertirAMayusculas(control: FormControl) {
    const valorIngresado = control.value;
    control.setValue(valorIngresado.toUpperCase(), {emitEvent: false});
  }

  private obtenerValidacionRangoDeEdad(value: TipoIdentificacion) {
    this.beneficiary.get("fechaNacimiento").setValue(null);
    let minimaFechaYMaximaFecha: any;
    if (value) {
      minimaFechaYMaximaFecha =
        this._validacionesFechaNacimientoSvc.reglasSegunParentescoYDocumentoDeIndentificacion(
          this.workerData,
          this.beneficiary.get("parentescoPerCarg").value.id,
          this.beneficiary.get("tipoDocumentoObjeto").value.valor,
          this.beneficiary.get("discapacidad").value
        );

      this.minimaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaDesde
        : null;
      this.maximaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaHasta
        : null;
      this.beneficiary
        .get("fechaNacimiento")
        .setValidators([
          Validators.required,
          ValidatorsCustom.validarFechaMinimoYMaximo(
            this.minimaFecha,
            this.maximaFecha
          ),
        ]);
      this.beneficiary
        .get("numeroDocumento")
        .setValidators([
          Validators.required,
          Validators.minLength(value.min),
          Validators.maxLength(value.max),
          Validators.pattern(value.expresionRegular),
          ValidatorsCustom.validadorDocumentoDiferenteTrabajador(() => this.afiliadoData?.afiliado.numeroDocumento ?? '' ),
          ValidatorsCustom.documentoDiferenteConyuge(() =>
            this.form.get("conyuge.NumIdConyuge")?.value
          ),
          ValidatorsCustom.documentoDiferenteBeneficiarios(() => this.getBeneficiariosDocs())
        ]);
    }
  }

  getBeneficiariosDocs(): string[] {
    const pacs = this.form.get('pacs');

    if (pacs instanceof FormArray) {
      const beneficiarios = pacs.controls
        .map((beneficiario: FormGroup) =>
          beneficiario.get('numeroDocumento')?.value
        ) || [];

      return beneficiarios.filter((beneficiarioDoc, idx) => idx !== this.index);
    }
    return [];
  }

  showCalendarFromBlurDocument(event: any) {
    let indice = event.target.id.split("_")[1];
    document.getElementById(`fechaNacimiento_${indice}`).click();
  }


  showCalendar(event: any) {
    document.getElementById(event.target.id).click();
  }

  async obtenerSolicitudesDeAcreditadorEnProcesoDeAfiliado(tipoIdentidadBeneficiario: String, numeroIdentidadBeneficiario: String) {
    if (this.tipoSolicitud != obtenerSolicitudTipoId(SolicitudTiposEnum.AFB)) {
      return
    }
    const params: ParametrosSolicitudValida = new ParametrosSolicitudValida();
    const tipoSolicitudId = obtenerSolicitudTipoId(SolicitudTiposEnum.AFB);
    const solicitudesCM = await this.obtenerSolicitudesPorTipo(tipoIdentidadBeneficiario, numeroIdentidadBeneficiario, tipoSolicitudId);
    const solicitudesEnProceso = solicitudesCM.filter(item => item.numeroDocumentoBeneficiario.includes(numeroIdentidadBeneficiario)
      && item.solicitudesEntity?.numeroIdentidadTitular.includes(this.workerData.validacion_afiliado.afiliado.numeroDocumento)
      && item.solicitudesEntity?.tipoIdentidadTitular.includes(this.workerData.validacion_afiliado.afiliado.tipoDocumento)).length;
    if (solicitudesEnProceso > 0) {
      this.coincidenciaEncontrada = true;
      this.beneficiary.reset();
      this.form.reset();
      this._ModalVariadoService.modalAlerta('Este beneficiario ya tiene una solicitud en curso o se encuentra afiliado');
    }

        params.affiliateDocument = this.afiliadoData.afiliado.numeroDocumento;
    params.affiliateTypeDocument = this.afiliadoData.afiliado.tipoDocumento;
    this.requestService.getDataRequestValid(params).subscribe(
      (res) => {
        {
          this.solicitudesEnProcesoAcreditador = !ValidateData.emptyObject(res.body)
            ? res.body
            : new Array<BodyRequestValid>();

          const beneficiarioExistente = (list: any[], key: string) =>
            list.some(item => item[key] === numeroIdentidadBeneficiario);

          const estadosPendientes = this.solicitudesEnProcesoAcreditador.filter(item => (item.status=== 1 || item.status === 2) && (item.documentNumberBeneficiary === numeroIdentidadBeneficiario))
          if (beneficiarioExistente(this.afiliadoData.pacs, 'numeroDocumento')) {
            this.coincidenciaEncontrada = true;
            this._ModalVariadoService.modalAlerta('Este beneficiario ya tiene una solicitud en curso o se encuentra afiliado');
            this.beneficiary.reset();
            this.form.reset();
          }else{
            if (beneficiarioExistente(this.solicitudesEnProcesoAcreditador, 'documentNumberBeneficiary') && estadosPendientes.length>0) {
              this.coincidenciaEncontrada = true;
              this._ModalVariadoService.modalAlerta('Este beneficiario ya tiene una solicitud en curso o se encuentra afiliado');
              this.beneficiary.reset();
              this.form.reset();
            }
          }
        }
      }
      ,
      (error) => {
        console.error("error verificando solicitudes en curso: " + error.message);
      }
    );
    this.solicitudesDeAfiliadoCargadas = true;
  }

  async obtenerSolicitudesPorTipo(tipoIdentidadBeneficiario, numeroIdentidadBeneficiario: any, tiposSolicitud: number): Promise<any> {
    const fechaDesde = new Date();
    fechaDesde.setMonth(fechaDesde.getMonth() - 2);
    fechaDesde.setHours(0, 0, 0, 0);

    const fechaHasta = new Date();
    fechaHasta.setHours(23, 59, 59, 999);
    const desde = fechaDesde.toISOString();
    const hasta = fechaHasta.toISOString();
    const portal = 2;
    const estados = [EstadoSolicitud.EN_PROCESO,
      EstadoSolicitud.DEVOLUCION,
      EstadoSolicitud.DEVOLUCION_SUBSANADA,
      EstadoSolicitud.APROBADO,
      EstadoSolicitud.APROBADO_PARCIAL,
      EstadoSolicitud.COMPLETADO_PARCIAL,
      EstadoSolicitud.EN_VALIDACION_INTERNA];
    try {
      const resp: DetalleSolicitudModel[] = await this.gestorSolicitudesConsultas.obtenerSolicitudesPorTipoYEstados(tipoIdentidadBeneficiario,
        numeroIdentidadBeneficiario,
        desde,
        hasta,
        tiposSolicitud,
        portal,
        estados
      ).toPromise();
      return resp;

    } catch (error) {
      console.error('Ocurrió un error al consultar la solicitudes: ', error);
      return [];
    }
  }

  public onBlurBeneficiario(){
    this.mostrarCargando();
    const tipoDoc = this.beneficiary.get("tipoDocumentoObjeto").value;
    const tipoParentesco = this.beneficiary.get("parentescoPerCarg").value;
    if(tipoDoc != '' && tipoParentesco != ''){
      this.buscarDatosBeneficiario(tipoDoc.valor);
    }
  }

  // Se busca como nsi el beneficiario fuese un afiliado normal
  private buscarDatosBeneficiario(tipoDoc: string) {
    if(this.infoTitularAfiliado
      && this.infoTitularAfiliado.tipoDocumento === tipoDoc &&
      this.infoTitularAfiliado.numeroDocumento ===
      this.beneficiary.get("numeroDocumento")?.value){
        this.ocultarCargando();
        return;
    }

    const typeDocument = tipoDoc;
    const document = this.beneficiary.get("numeroDocumento")?.value;

    const beneficiarioAfiliado = this.buscarBeneficiarioAfiliado(typeDocument, document);


    if (beneficiarioAfiliado) {
      this.llenarFormularioAfiliado(beneficiarioAfiliado);
      this.ocultarCargando();
      return;
    }

    this._affiliationService.getInfoAffiliateBasic(typeDocument, document).pipe(
      tap((response: IAffiliateInformation | null) => {
        this.limpiarDatosFormulario();
        if (!response) return;

        const { informacionAfiliado, informacionBeneficiario } = response;

        if (informacionAfiliado?.numeroDocumento === document && informacionAfiliado?.tipoDocumento === typeDocument) {
          this.llenarFormularioAfiliado(informacionAfiliado);
          this.agregarBeneficiario(informacionAfiliado);
          this._affiliationService.actualizarBeneficiarios(this.infoBeneficiarioAfiliado);
          return;
        }

        // Caso: Beneficiario encontrado
        const beneficiarioEncontrado = informacionBeneficiario?.find(
          b => b.numeroDocumento === document && b.tipoDocumento === typeDocument
        );

        if (beneficiarioEncontrado) {
          this.llenarFormularioAfiliado(beneficiarioEncontrado);
          this.agregarBeneficiario(beneficiarioEncontrado);
          this._affiliationService.actualizarBeneficiarios(this.infoBeneficiarioAfiliado);
        }
      }),
      finalize(() => this._spinner.hide())
    ).subscribe();
  }

  private agregarBeneficiario(data: any) {
    this.infoBeneficiarioAfiliado.push({
      numeroDocumento: data.numeroDocumento,
      tipoDocumento: data.tipoDocumento,
      primerNombre: data.primerNombre,
      segundoNombre: data.segundoNombre,
      primerApellido: data.primerApellido,
      segundoApellido: data.segundoApellido,
      fechaNacimiento: data.fechaNacimiento,
      genero: data.genero,
      parentesco: this.beneficiary.get("parentescoPerCarg")?.value?.name
    });
  }


  llenarFormularioAfiliado(afiliado: IAffiliateTitular | IAffiliateBeneficiary): void {
    const fechaISO = afiliado.fechaNacimiento;
    const fechaFormateada = fechaISO?.split('T')[0] ?? '';

    this.beneficiary.get('primerNombre')?.setValue(afiliado.primerNombre);
    this.beneficiary.get('segundoNombre')?.setValue(afiliado.segundoNombre);
    this.beneficiary.get('apellido')?.setValue(afiliado.primerApellido);
    this.beneficiary.get('segundoApellido')?.setValue(afiliado.segundoApellido);
    this.beneficiary.get('genero')?.setValue(afiliado.genero);
    const fechaControl = this.beneficiary.get('fechaNacimiento');
    fechaControl.setValue(afiliado.fechaNacimiento.split('T')[0]);
    fechaControl.markAsTouched();
    fechaControl.updateValueAndValidity();


    this.ocultarCargando();
  }

  buscarBeneficiarioAfiliado(tipoDocumento: string, numeroDocumento: string): IAffiliateBeneficiary | undefined {
    if(this.infoBeneficiarioAfiliado){
        return this.infoBeneficiarioAfiliado.find(
        b => b.tipoDocumento === tipoDocumento && b.numeroDocumento === numeroDocumento
      );
    }
    return undefined;
  }

  private mostrarCargando(): void {
    this._spinner.show();
  }

  private ocultarCargando(): void {
    this._spinner.hide();
  }

  private limpiarDatosFormulario() {
    const afilaido: Partial<IAffiliateBeneficiary> = {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      fechaNacimiento: '',
      genero: '',
      parentesco: ''
    };
    this.llenarFormularioAfiliado(afilaido as IAffiliateBeneficiary);
  }


  private validacionDireccionBeneficiario(): void {
    const controlDireccion = this.beneficiary?.get('direccionResidencia');

    if (!controlDireccion) {
      return;
    }

    const validadorActual = controlDireccion.validator;

    controlDireccion.setValidators(
      validadorActual
        ? [validadorActual, Validators.maxLength(60)]
        : [Validators.maxLength(60)]
    );

    controlDireccion.updateValueAndValidity();
  }

}
